import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials makes the browser attach the httpOnly `session_token`
// cookie on every /api call. Required for the Emergent Auth flow + any
// future user-scoped endpoint (shortlist, watchlist alerts, etc.).
export const api = axios.create({
  baseURL: API,
  timeout: 90000,
  withCredentials: true,
});

export const analyzeListing = (payload) => api.post("/analyze", payload).then((r) => r.data);
export const listAnalyses = (params = {}) => api.get("/analyses", { params }).then((r) => r.data);
export const getAnalysis = (id) => api.get(`/analyses/${id}`).then((r) => r.data);
export const deleteAnalysis = (id) => api.delete(`/analyses/${id}`).then((r) => r.data);
export const getFeed = (params = {}) => api.get("/feed", { params }).then((r) => r.data);
export const getDigest = (params = {}) => api.get("/digest", { params }).then((r) => r.data);
export const refreshFeed = (token) =>
  api
    .post("/feed/refresh", null, token ? { headers: { "X-Admin-Token": token } } : {})
    .then((r) => r.data);
export const listWatchlists = () => api.get("/watchlist").then((r) => r.data);
export const createWatchlist = (payload) => api.post("/watchlist", payload).then((r) => r.data);
export const deleteWatchlist = (id) => api.delete(`/watchlist/${id}`).then((r) => r.data);
export const checkAllWatchlists = () => api.get("/watchlist/check_all").then((r) => r.data);
export const crawlFeed = (token, params = {}) =>
  api
    .post("/feed/crawl", null, {
      params,
      headers: token ? { "X-Admin-Token": token } : {},
      timeout: 240000,
    })
    .then((r) => r.data);

// ---------- Auth ----------
export const exchangeSession = (session_id) =>
  api.post("/auth/session", { session_id }).then((r) => r.data);

// ---------- Shortlist ----------
export const addToShortlist = (feed_id, note) =>
  api.post("/shortlist", { feed_id, note }).then((r) => r.data);
export const removeFromShortlist = (id) =>
  api.delete(`/shortlist/${id}`).then((r) => r.data);
export const listShortlist = () => api.get("/shortlist").then((r) => r.data);
export const getShortlistIds = () =>
  api.get("/shortlist/ids").then((r) => r.data?.feed_ids || []);


// ---------- Quota / Billing ----------
export const getQuota = () => api.get("/quota").then((r) => r.data);
export const getExamples = (limit = 3) =>
  api.get("/examples", { params: { limit } }).then((r) => r.data?.items || []);
export const startCreditCheckout = (origin_url) =>
  api.post("/billing/checkout/credit", { origin_url }).then((r) => r.data);
export const startPremiumCheckout = (origin_url) =>
  api.post("/billing/checkout/premium", { origin_url }).then((r) => r.data);
export const getCheckoutStatus = (session_id) =>
  api.get(`/billing/checkout/status/${session_id}`).then((r) => r.data);
export const getBillingMe = () => api.get("/billing/me").then((r) => r.data);
